import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { contact } from "../utils/environments/api";

const AboutUs = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  // Popup open chesinapudu current scroll position calculate chey
  const handleOpenPopup = () => {
    const scrollY = window.scrollY || window.pageYOffset;
    const centerX = window.innerWidth / 2;
    
    setPopupPosition({
      top: scrollY + 100, // Scroll position paina 100px gap
      left: centerX
    });
    setShowPopup(true);
  };

  const stats = [
    { number: "64+", label: "Projects Completed" },
    { number: "15+", label: "Team Members" },
    { number: "98%", label: "Client Satisfaction" },
  ];

  const services = [
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M17 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z" />
          <circle cx="5" cy="12" r="2" />
          <circle cx="19" cy="4" r="2" />
          <circle cx="19" cy="20" r="2" />
          <path d="M12 3h2v2h-2zM12 19h2v2h-2zM3 12h2v2H3zM19 12h2v2h-2z" />
        </svg>
      ),
      title: "IoT Solutions",
      description:
        "End-to-end IoT development from sensor integration to cloud platforms and real-time analytics",
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z" />
        </svg>
      ),
      title: "Mobile Applications",
      description:
        "Native and cross-platform mobile apps for iOS and Android with seamless user experiences",
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
        </svg>
      ),
      title: "Web Development",
      description:
        "Scalable web applications with modern frameworks and cutting-edge technologies",
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M19 8l-4 4h3c0 3.31-2.69 6-6 6-1.01 0-1.97-.25-2.8-.7l-1.46 1.46C8.97 19.54 10.43 20 12 20c4.42 0 8-3.58 8-8h3l-4-4zM6 12c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46C15.03 4.46 13.57 4 12 4c-4.42 0-8 3.58-8 8H1l4 4 4-4H6z" />
        </svg>
      ),
      title: "Product Development",
      description:
        "Innovation-driven research and development for cutting-edge technological solutions",
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M3 13h2v-2H3v2zm4 0h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h6v-2h-6v2zm0 4h6v-2h-6v2zm0-8h6V7h-6v2zM3 9h2V7H3v2zm0 8h2v-2H3v2zm4 0h2v-2H7v2z" />
        </svg>
      ),
      title: "Utilities",
      description:
        "Smart energy, water, and asset monitoring systems powered by IoT for real-time insights and control.",
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17v-2h2v2h-2zm0-4V7h2v8h-2z" />
        </svg>
      ),
      title: "Digital Marketing",
      description:
        "Comprehensive marketing solutions including SEO, social media, and performance campaigns to grow your brand online.",
    },
  ];

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
     webiste: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(null);

    try {
      const res = await fetch("https://vincosys.com/backend/api/post_contact_api.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (res.ok) {
        setSuccess(true);
        setFormData({ name: "", email: "", message: "" });
        setTimeout(() => {
          setShowPopup(false);
          setSuccess(null);
        }, 2000);
      } else {
        setSuccess(false);
      }
    } catch (error) {
      console.error(error);
      setSuccess(false);
    } finally {
      setLoading(false);
    }
  };

  const values = [
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
        </svg>
      ),
      title: "Quality Excellence",
      description:
        "We maintain the highest standards in every project, ensuring robust and scalable solutions.",
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
        </svg>
      ),
      title: "Client Partnership",
      description:
        "We build long-term relationships, working as an extension of your team to achieve shared goals.",
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M13 2.05v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zM12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53C16.17 17.98 14.21 19 12 19z" />
        </svg>
      ),
      title: "Innovation Driven",
      description:
        "We continuously explore emerging technologies to deliver future-ready solutions.",
    },
  ];

  return (
    <div className={`about-us-page ${isVisible ? "visible" : ""}`}>
      {/* Hero Section */}
       <div class="page-title">
               <div
                 class="pattern-layer-one"
                 // style={{
                 //   backgroundImage:
                 //     "url(../../assets/Images/background/pattern-16.png)",
                 // }}
               ></div>
               <div class="container">
                 <h2>About Us</h2>
                 <ul class="page-breadcrumb">
                   <li>
                     <Link to="/">home&gt;</Link>
                   </li>
                   <li>About</li>
                 </ul>
               </div>
             </div>

      {/* About Section */}
      <section className="container">
        <div className="about-section">
          <div className="auto-container">
            <div className="sec-title">
              <div className="title">ABOUT COMPANY</div>
            </div>
            <div className="row clearfix">
              <div className="content-column col-lg-6 col-md-12 col-sm-12">
                <div className="inner-column">
                  <div className="text">
                    At Vincosys, we are passionate about transforming innovative
                    ideas into powerful digital solutions that drive growth and
                    success. As a dynamic technology company, we specialize in
                    creating customized digital solutions that elevate
                    businesses in today's fast-paced tech landscape. With a
                    diverse team of experts, we bring together deep industry
                    knowledge and the latest advancements in technology to
                    deliver robust solutions tailored to meet our clients'
                    unique needs.
                  </div>
                  <div className="text">
                    Our expertise spans a wide range of services, from Internet
                    of Things (IoT) solutions to mobile app development and
                    web-based applications. We understand the complexities of
                    modern business environments and provide comprehensive
                    services that streamline processes, enhance user
                    experiences, and unlock new growth opportunities.
                  </div>
                  <div className="blocks-outer">
                    <div className="feature-block">
                      <div className="inner-box">
                        <div className="icon">
                          <i className="ri-award-fill"></i>
                        </div>
                        <h6>Experience</h6>
                        <div className="feature-text">
                          Our great team of more than 30 software experts.
                        </div>
                      </div>
                    </div>
                    <div className="feature-block">
                      <div className="inner-box">
                        <div className="icon">
                          <i className="ri-settings-2-line"></i>
                        </div>
                        <h6>Solutions</h6>
                        <div className="feature-text">Future-Focused Solutions</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="images-column col-lg-6 col-md-12 col-sm-12">
                <div className="inner-column">
                  <div className="main">
                    <div className="pattern-layer"></div>
                  </div>
                  <div className="images-outer parallax-scene-1">
                    <div className="image" data-depth="0.10">
                      <img
                        src="../../assets/Images/resource/about-1.jpg"
                        alt=""
                      />
                    </div>
                    <div className="image-two" data-depth="0.30">
                      <img
                        src="../../assets/Images/resource/about-2.jpg"
                        alt=""
                      />
                    </div>
                    <div className="image-three" data-depth="0.20">
                      <img
                        src="../../assets/Images/resource/about-3.jpg"
                        alt=""
                      />
                    </div>
                    <div className="image-four" data-depth="0.30">
                      <img
                        src="../../assets/Images/resource/about-4.jpg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="content-column col-lg-12 col-md-12 col-sm-12">
                <div className="inner-column">
                  <div className="text">
                    At Vincosys, we pride ourselves on our commitment to
                    excellence, quality, and client satisfaction. We don't just
                    deliver technology – we deliver solutions that enable
                    businesses to stay competitive and thrive. By partnering
                    with us, our clients gain access to leading-edge technology
                    solutions designed to help them adapt and succeed in an
                    ever-evolving digital world. Whether it's building a secure
                    IoT network, developing a custom mobile application, or
                    creating a responsive web platform, we are dedicated to
                    turning vision into reality and empowering businesses to
                    achieve their goals. Let Vincosys be your partner in
                    navigating the digital age, with customized strategies and
                    cutting-edge technology that propel your business toward
                    sustainable growth and success. Choosing Vincosys
                    as your technology partner means having a dedicated
                    collaborator focused on your long-term success. We emphasize
                    flexibility, innovation, and growth in every solution we
                    deliver, ensuring our technologies adapt to your industry's
                    changing needs. Our goal is to empower businesses to not
                    only thrive but to lead, creating lasting impact in a
                    digital-first world.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision Section */}
      <div className="mission-section">
        <div className="container">
          <div className="mission-grid">
            <div className="mission-card">
              <div className="card-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.78-1.18 2.73-3.12 3.16z" />
                </svg>
              </div>
              <h3>Our Mission</h3>
              <p>
                To empower businesses with cutting-edge technology solutions
                that drive innovation, enhance efficiency, and create
                sustainable competitive advantages in the digital era.
              </p>
            </div>
            <div className="mission-card">
              <div className="card-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-5.5-2.5l7.51-3.49L17.5 6.5 9.99 9.99 6.5 17.5zm5.5-6.6c.61 0 1.1.49 1.1 1.1s-.49 1.1-1.1 1.1-1.1-.49-1.1-1.1.49-1.1 1.1-1.1z" />
                </svg>
              </div>
              <h3>Our Vision</h3>
              <p>
                To be the leading global technology partner recognized for
                delivering transformative digital solutions that shape the
                future of businesses across industries worldwide.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Services Section */}
      <div className="services-section">
        <div className="container">
          <div className="section-header">
            <h2>Our Core Services</h2>
            <p>
              Comprehensive technology solutions tailored to your business needs
            </p>
          </div>
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="service-card">
                <div className="service-icon">{service.icon}</div>
                <h4>{service.title}</h4>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Values Section */}
      <div className="values-section">
        <div className="container">
          <div className="section-header">
            <h2>Our Values</h2>
            <p>The principles that guide everything we do</p>
          </div>
          <div className="values-grid">
            {values.map((value, index) => (
              <div key={index} className="value-card">
                <div className="value-icon">{value.icon}</div>
                <h4>{value.title}</h4>
                <p>{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="cta-section mb-4">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Transform Your Business?</h2>
            <p>
              Let's discuss how our technology solutions can drive your success
            </p>
            <div className="cta-buttons">
              <button
                onClick={handleOpenPopup}
                className="cta-btn primary"
              >
                Get In Touch
              </button>
              <Link to="/services" className="cta-btn secondary">
                Our Services
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Popup - Current scroll position paina */}
      {showPopup && (
        <div className="popup-overlay" onClick={() => setShowPopup(false)}>
          <div 
            className="popup-content" 
            onClick={(e) => e.stopPropagation()}
            style={{
              position: 'absolute',
              top: `${popupPosition.top}px`,
              left: '50%',
              transform: 'translateX(-50%)'
            }}
          >
            <button
              onClick={() => setShowPopup(false)}
              className="popup-close"
            >
              ✖
            </button>

            <h3 className="popup-title">Contact Us</h3>
            <form onSubmit={handleSubmit} className="popup-form">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Your Name"
                required
                className="form-input"
              />
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Your Email"
                required
                className="form-input"
              />
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Your Message"
                rows="4"
                required
                className="form-textarea"
              ></textarea>

              <button
                type="submit"
                disabled={loading}
                className="submit-button"
              >
                {loading ? "Sending..." : "Send Message"}
              </button>
            </form>

            {success === true && (
              <p className="success-message">Message sent successfully!</p>
            )}
            {success === false && (
              <p className="error-message">Something went wrong. Please try again.</p>
            )}
          </div>
        </div>
        
      )}

      <style jsx>{`
        .popup-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          width:100%;
          height:100%;
          background: rgba(0, 0, 0, 0.5);
           z-index: 999999 !important;
            display: flex;
  align-items: flex-start;
  justify-content: center;
  overflow-y: auto;
        }

        .popup-content {
          background: white;
          border-radius: 16px;
          padding: 32px;
          width: 90%;
          max-width: 480px;
          position: fixed;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
          animation: slideDown 0.3s ease-out;
          margin-top: 20px;
        }

        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateX(-50%) translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateX(-50%) translateY(0);
          }
        }

        .popup-close {
          position: absolute;
          top: 7px;
          right: 10px;  
          background: none;
          border: none;
          font-size: 20px;
          cursor: pointer;
          color: #666;
          padding: 4px;
        }

        .popup-close:hover {
          color: #000;
        }

        .popup-title {
          font-size: 24px;
          font-weight: 600;
          margin-bottom: 24px;
          text-align: center;
          color: #1f2937;
        }

        .popup-form {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }

        .form-input,
        .form-textarea {
          width: 100%;
          border: 1px solid #d1d5db;
          border-radius: 8px;
          padding: 12px 16px;
          font-size: 14px;
          transition: all 0.2s;
        }

        .form-input:focus,
        .form-textarea:focus {
          outline: none;
          border-color: #3b82f6;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
        }

        .submit-button {
          width: 100%;
          background: #2563eb;
          color: white;
          border: none;
          border-radius: 8px;
          padding: 12px 24px;
          font-size: 16px;
          font-weight: 500;
          cursor: pointer;
          transition: background 0.2s;
        }

        .submit-button:hover:not(:disabled) {
          background: #1d4ed8;
        }

        .submit-button:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .success-message {
          color: #059669;
          text-align: center;
          margin-top: 16px;
          font-size: 14px;
        }

        .error-message {
          color: #dc2626;
          text-align: center;
          margin-top: 16px;
          font-size: 14px;
        }

        /* Mobile responsiveness */
        @media (max-width: 768px) {
          .popup-content {
            width: 95%;
            padding: 24px;
            margin-top: 10px;
          }
          
          .popup-title {
            font-size: 20px;
          }
        }
      `}</style>
    </div>
  );
};

export default AboutUs;